<h1 mat-dialog-title>Add/Edit Site Visit</h1>

<div mat-dialog-content [formGroup]="form">
  <div class="flex flex-col justify-start items-stretch">
    <div class="flex flex-row justify-start items-center gap-x-2">
      <mat-form-field>
        <mat-label>Visit Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Visit time</mat-label>
        <input matInput name="time" formControlName="time" (blur)="updateTimeEnteredManually('time', pickerOff)"
          placeholder="Visit time" />
        @if (form.get('time').hasError('invalidTime')) {
        <mat-error>Invalid time value, please enter in the format: HH:mm (24
          hour)</mat-error>
        }
        <mat-icon matSuffix (click)="pickerOff.open()">access_time</mat-icon>
      </mat-form-field>
      <ngx-mat-timepicker [format]="24" enableKeyboardInput dottedMinutesInGap (timeSet)="updateTime($event, 'time')"
        #pickerOff></ngx-mat-timepicker>
    </div>
    <a (click)="toggleTypeAddress()" class="self-end cursor-pointer">{{
      typeAddress ? 'Search for Address' : 'Type Address'
      }}</a>
    @if (typeAddress) {
    <mat-form-field>
      <mat-label>Site Address</mat-label>
      <textarea matInput cdkTextareaAutosize formControlName="typedAddress"></textarea>
    </mat-form-field>
    } @else {
    <app-address-search-field formControlName="address" label="Site Address"></app-address-search-field>
    }
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-flat-button matDialogClose>Cancel</button>
  <button mat-flat-button color="primary" [disabled]="!form.valid" (click)="save()">
    Save
  </button>
</div>